/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { PositionService } from './position.service';
import { SplitPaneComponent } from './split-pane.component';

@Component({
  standalone: false,
  selector: 'gh-horizontal-split-pane',
  styles: [`
      .h-outer {
          height: 100%;
          width: 100%;
          display: flex;
          flex-flow: column;
      }

      .upper-component {
          height: calc(50% - 4px);
      }

      .lower-component {
          height: calc(50% - 4px);
      }
  `],
  template: `
    <div #outer class="h-outer">
      <div
        #primaryComponent
        [hidden]="primaryToggledOff"
        class="upper-component">
        <ng-content select=".split-pane-content-primary"></ng-content>
      </div>
      <gh-horizontal-split-separator
        #separator
        [hidden]="primaryToggledOff || secondaryToggledOff"
        [thickness]="separatorThickness"
        (notifyWillChangeSize)="notifyWillChangeSize($event)">
      </gh-horizontal-split-separator>
      <div
        #secondaryComponent
        [hidden]="secondaryToggledOff"
        class="lower-component">
        <ng-content select=".split-pane-content-secondary"></ng-content>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HorizontalSplitPaneComponent extends SplitPaneComponent {

  @ViewChild('outer', { static: false }) outerContainer: ElementRef;
  @Input() test: number;

  constructor(element: ElementRef) {
    super(element);
  }

  getTotalSize(): number {
    return this.outerContainer.nativeElement.offsetHeight;
  }

  getPrimarySize(): number {
    return this.primaryComponent.nativeElement.offsetHeight;
  }

  getSecondarySize(): number {
    return this.secondaryComponent.nativeElement.offsetHeight;
  }

  dividerPosition(size: number): void {
    const sizePct = (size / this.getTotalSize()) * 100.0;
    this.primaryComponent.nativeElement.style.height = sizePct + '%';
    this.secondaryComponent.nativeElement.style.height =
      `calc(${100 - sizePct}% - ${this.primaryToggledOff || this.secondaryToggledOff ? 0 : this.separatorThickness}px)`;
  }

  onMouseMove(event: MouseEvent): void {
    const coords = PositionService.offset(this.primaryComponent);
    this.applySizeChange(event.pageY - coords.top);
    event.preventDefault();
  }
}
